import { render, staticRenderFns } from "./app-long-loading-modal.vue?vue&type=template&id=68aa35c2"
import script from "./app-long-loading-modal.vue?vue&type=script&lang=ts"
export * from "./app-long-loading-modal.vue?vue&type=script&lang=ts"
import style0 from "./app-long-loading-modal.vue?vue&type=style&index=0&id=68aa35c2&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68aa35c2')) {
      api.createRecord('68aa35c2', component.options)
    } else {
      api.reload('68aa35c2', component.options)
    }
    module.hot.accept("./app-long-loading-modal.vue?vue&type=template&id=68aa35c2", function () {
      api.rerender('68aa35c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-button/app-long-loading-modal.vue"
export default component.exports